module.exports = __webpack_public_path__ + "img/img3_4.7cf3fb06.jpeg";